import axios from '@axios'
import cfops from './cfops'
import taxClassifications from './taxClassification'
import fiscalTaxParameters from './fiscalTaxParameters'
import taxConfigurationGroups from './taxConfigurationGroups'
import invoice from './invoice'
import invoiceReceived from './invoice-received'
import fiscalFiles from './fiscal-files'
import invalidate from './invalidate'

const REFERENCE_IN_ITEM_FOR_RETURN_KEY = 'invoices_rule.reference_in_item_for_return'
const DEBIT_FOR_STOCK_LOSS_KEY = 'invoices_rule.debit_for_stock_loss'

// o valor vem como string json (ex: '["SP","MA"]') ou nulo quando o parâmetro não existe.
// falha na busca não pode quebrar a tela: sem UF, a feature flag fica desligada
const fetchProvincesParameter = async key => {
  try {
    const { data } = await axios.get(`/api/parameter/${key}`)

    return JSON.parse(data?.value) ?? []
  } catch {
    return []
  }
}

const getInitialState = () => ({
  // UFs que aplicam a referência dentro do item na nota de devolução
  statesCanReferenceInItemForReturn: [],
  // UFs que emitem nota de débito na baixa de estoque
  statesCanDebitForStockLoss: [],
})

export default {
  namespaced: true,
  modules: {
    cfops,
    taxClassifications,
    fiscalTaxParameters,
    taxConfigurationGroups,
    invoice,
    invoiceReceived,
    fiscalFiles,
    invalidate,
  },
  state: getInitialState(),
  getters: {
    getStatesCanReferenceInItemForReturn: state => state.statesCanReferenceInItemForReturn,
    getStatesCanDebitForStockLoss: state => state.statesCanDebitForStockLoss,
    canDebitForStockLossByProvince: state => province =>
      Boolean(province) && state.statesCanDebitForStockLoss.includes(province),
  },
  mutations: {
    SET_REFERENCE_IN_ITEM_FOR_RETURN(state, provinces) {
      state.statesCanReferenceInItemForReturn = provinces
    },
    SET_DEBIT_FOR_STOCK_LOSS(state, provinces) {
      state.statesCanDebitForStockLoss = provinces
    },
  },
  actions: {
    async fetchInvoiceParameters({ dispatch }) {
      await Promise.all([
        dispatch('fetchReferenceInItemForReturn'),
        dispatch('fetchDebitForStockLoss'),
      ])
    },

    async fetchReferenceInItemForReturn({ commit }) {
      const provinces = await fetchProvincesParameter(REFERENCE_IN_ITEM_FOR_RETURN_KEY)

      commit('SET_REFERENCE_IN_ITEM_FOR_RETURN', provinces)

      return provinces
    },

    async fetchDebitForStockLoss({ commit }) {
      const provinces = await fetchProvincesParameter(DEBIT_FOR_STOCK_LOSS_KEY)

      commit('SET_DEBIT_FOR_STOCK_LOSS', provinces)

      return provinces
    },
  },
}
